import React, { Component } from "react";
import PropTypes from "prop-types";

import CultureRow from "./CultureRow";
import AddableRow from "../AddableRow";

const emptyRow = {
  culture_id: "",
  name: "",
  volume: 0,
  price: "",
  price_calc: "",
  quality_comment: "",
  is_full_cropped: false,
  year: 0,
  new: true
};

class CulturesList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      list: props.list || []
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.list && nextProps.list !== this.state.list) {
      this.setState({
        list: nextProps.list
      });
    }
  }

  handleItemChange = (name, value, index, cultureName) => {
    const { list } = this.state;
    const item = list[index];
    item[name] = value;
    if (cultureName) {
      item.name = cultureName;
    }
    list[index] = item;
    this.setState(
      {
        list
      },
      this.updateState
    );
  };

  addRow = () => {
    const newItem = { ...emptyRow };
    this.setState(
      prevState => ({
        list: [...prevState.list, newItem]
      }),
      this.updateState
    );
  };

  removeRow = index => {
    const { list } = this.state;
    const item = list[index];
    if (+this.props.type === 1) {
      this.props.moveToCroppedList(item.culture_id, true);
    } else {
      list.splice(index, 1);
      this.setState(
        {
          list
        },
        this.updateState
      );
    }
  };

  updateState = () => {
    this.props.updateState(this.state.list, "cultures");
  };

  render() {
    const { cultures, isEditMode, type, showDeleteAction } = this.props;
    const { list } = this.state;
    return (
      <div className="cultures-list">
        {list
          ? list.map((row, key) => (
              <AddableRow
                key={key}
                rowKey={key}
                onRemove={this.removeRow}
                showDeleteAction={showDeleteAction}
              >
                <CultureRow
                  rowData={row}
                  isEditMode={isEditMode}
                  rowKey={key}
                  cultures={cultures}
                  onChange={this.handleItemChange}
                  type={type}
                  contract={row.contract || 0}
                  radioSelected={this.props.radioSelected}
                  calculateTheBestOffers={this.props.calculateTheBestOffers}
                  openSalesOrdersModal={this.props.openSalesOrdersModal}
                  getSalesOrdersByCulture={this.props.getSalesOrdersByCulture}
                />
              </AddableRow>
            ))
          : null}

        <div className="add-row-button" onClick={this.addRow}>
          <i className="fi flaticon-add" />
          <span className="description">Добавить культуру</span>
        </div>
      </div>
    );
  }
}

CulturesList.propTypes = {
  cultures: PropTypes.array,
  isEditMode: PropTypes.bool,
  showDeleteAction: PropTypes.bool,
  list: PropTypes.array,
  moveToCroppedList: PropTypes.func,
  type: PropTypes.number,
  updateState: PropTypes.func,
  calculateTheBestOffers: PropTypes.func,
  openSalesOrdersModal: PropTypes.func,
  getSalesOrdersByCulture: PropTypes.func,
};

export default CulturesList;



// WEBPACK FOOTER //
// ./components/ClientForm/Cultures/CulturesList.js